import { createFileRoute } from "@tanstack/react-router";
import { TrainingHistory } from "@/features/training-history/ui/panel";

export const Route = createFileRoute("/history")({
  component: HistoryPage,
});

function HistoryPage(): React.JSX.Element {
  return <TrainingHistory />;
}
